import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PRIVATE_ROUTE } from "../../route.constants";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  IMG_BUSINESS_INFO_BG,
  IMG_BUSINESS_INFO_RIGHT_BG,
  IconUploadImage,
  IconArrowRight,
} from "@assets";
import { Button, Col, Input, message, Row, Form, Flex } from "antd";
import { CheckOutlined, CloseCircleFilled } from "@ant-design/icons";
import { updateIsNewUser } from "../../store/auth/authSlice";
import api from "../../api/api";

const RootContainer = styled.div`
  min-height: 100vh;
  background-image: url(${IMG_BUSINESS_INFO_BG});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const BoldText = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: ${(props) => props.theme.primaryColor};
  text-align: center;
`;

const BoldTextWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
  padding-bottom: 24px;
`;

const Line = styled.div`
  width: 48px;
  height: 4px;
  background: ${(props) => props.theme.primaryColor};
  border-radius: 999px;
`;

const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  background: ${(props) => props.theme.backgroundColor};
  overflow: hidden;
`;

const LeftSide = styled.div`
  flex: 0.5;
  // height: 100%;
  padding: 24px;
  background-color: #fff;
  // border-top-left-radius: 24px;
  // border-bottom-left-radius: 24px;
`;

const RightSide = styled.div`
  flex: 0.5;
  height: 100%;
  padding: 0 24px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .ant-btn-default {
    width: 100px;
    height: 40px;
    background: ${(props) => props.theme.backgroundColor};
    border: none !important;
    color: ${(props) => props.theme.primaryColor} !important;
    font-size: 16px;
    font-weight: 600;

    :hover {
      background: ${(props) => props.theme.backgroundColor} !important;
      border: none !important;
      color: ${(props) => props.theme.primaryColor} !important;
    }
  }
`;

const TitleText = styled.div`
  flex: 1;
  font-size: 24px;
  font-weight: 700;
  color: ${(props) => props.theme.primaryColor};
`;

const Image = styled.img.attrs({
  alt: "img",
})`
  width: 200px;
  height: 200px;
  object-fit: cover;
  barder-radius: 8px;
`;

const Text = styled.div`
  padding: 20px 0;
  font-size: 16px;
  font-weight: 400;
  color: #1d1014;
  text-align: left;
`;

const GrayText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #b9b9b9;
  white-space: pre-wrap;
  text-align: center;
`;

const UploadBox = styled.div`
  cursor: pointer;
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  gap: 9px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  // overflow: hidden;
`;

const LightText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #686868;
  text-align: center;
  padding-top: 12px;
`;

const Box = styled.div`
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #b9b9b9;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  .anticon {
    position: absolute;
    top: -10px;
    right: -10px;
    font-size: 32px;
    color: #868686;
    cursor: pointer;
    z-index: 10;
  }
`;

const HiddenInput = styled(Input)`
  display: none;
  visibility: hidden;
`;

const BusinessInfo = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.token);
  const isNewUser = useSelector((state) => state.auth.isNewUser);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [data, setData] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [logoUrl, setLogoUrl] = React.useState("");
  const [file, setFile] = React.useState(null);
  const [confirmLoading, setConfirmLoading] = React.useState(false);

  const handleSkip = () => {
    dispatch(updateIsNewUser(false));
    doPost({
      name: {
        primary: data?.storeName,
        secondary: data?.storeName,
      },
    });
    navigate(`/${PRIVATE_ROUTE.HOME}/${PRIVATE_ROUTE.DASHBOARD}`);
  };

  const handleSave = () => {
    form.submit();
  };

  useEffect(() => {
    // getBusinessInformation();
    getCheckSubDomain();
  }, []);

  const getCheckSubDomain = () => {
    api
      .getCheckSubDomain()
      .then(({ data }) => {
        setLoading(false);
        setData(data);
        setLogoUrl(null);
        form.setFieldsValue({
          name_primary: data?.storeName || "",
        });
      })
      .catch((error) => {
        message.error(error);
      });
  };

  // const getBusinessInformation = () => {
  //   api
  //     .getBusinessInformation()
  //     .then(({ data }) => {
  //       setLoading(false);
  //       setData(data);
  //       setLogoUrl(data.logo);
  //       form.setFieldsValue({
  //         name_primary: data?.name?.primary || "",
  //       });
  //     })
  //     .catch((error) => {
  //       message.error(error);
  //     });
  // };

  const doPost = (payload) => {
    api
      .updateBusinessInformation(payload)
      .then(() => {
        setConfirmLoading(false);
        message.success("Success!");
        dispatch(updateIsNewUser(false));
        navigate(`/${PRIVATE_ROUTE.HOME}/${PRIVATE_ROUTE.DASHBOARD}`);
      })
      .catch((error) => {
        setConfirmLoading(false);
        message.error(error);
      });
  };

  const uploadImage = (payload) => {
    api
      .uploadMedia({
        file,
        file_path: file.type,
      })
      .then(({ data: { url } }) => {
        doPost({
          logo: url,
          ...payload,
        });
      })
      .catch((error) => {
        setConfirmLoading(false);
        message.error(error);
      });
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  const onFinish = ({ name_primary }) => {
    if (!confirmLoading) {
      setConfirmLoading(true);
      let payload = {
        name: {
          primary: name_primary,
          secondary: data?.name?.secondary ?? name_primary,
        },
      };
      if (file) {
        uploadImage(payload);
      } else {
        payload.logo = data.logo;
        doPost(payload);
      }
    }
  };

  const handleRemoveClicked = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFile(null);
    setLogoUrl(null);
  };

  const handleBoxClick = () => {
    document.getElementById("file-input").click();
  };

  return (
    <RootContainer>
      <Row>
        <Col xs={2} />
        <Col xs={20}>
          <BoldTextWrapper>
            <Line />
            <BoldText>Start setting up your online website</BoldText>
            <Line />
          </BoldTextWrapper>
          <Card>
            <Row style={{ width: "100%" }}>
              <Col xs={24} md={12}>
                <LeftSide>
                  <TitleWrapper>
                    <TitleText>Fill Business Information</TitleText>
                    <Button
                      type="default"
                      icon={<IconArrowRight />}
                      onClick={handleSkip}
                    >
                      Skip
                    </Button>
                  </TitleWrapper>
                  <Text>
                    Create a personalized and professional identity for your
                    business by adding your logo and business name.
                  </Text>
                  <Form form={form} onFinish={onFinish}>
                    <UploadBox>
                      <Box onClick={handleBoxClick}>
                        {file || logoUrl ? (
                          <>
                            <Image
                              src={file ? URL.createObjectURL(file) : logoUrl}
                              preview={false}
                            />
                            {/* <CloseCircleFilled onClick={handleRemoveClicked} /> */}
                          </>
                        ) : (
                          <>
                            <IconUploadImage />
                            <GrayText>{`Upload image or \n drop a file`}</GrayText>
                          </>
                        )}
                      </Box>
                    </UploadBox>
                    <LightText>500 px * 500 px, PNG, JPG, Up to 2 MB</LightText>
                    <HiddenInput
                      id="file-input"
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      // disabled={file}
                      hidden
                      onChange={handleFileChange}
                    />
                    <Flex style={{ flexDirection: "column" }}>
                      <Form.Item
                        name="name_primary"
                        rules={[
                          {
                            required: true,
                            message: "Business name is required",
                          },
                        ]}
                      >
                        <Input placeholder="Business Name" />
                      </Form.Item>
                      <Button
                        type="primary"
                        icon={<CheckOutlined />}
                        loading={confirmLoading}
                        onClick={handleSave}
                        style={{ width: "100%", height: 48 }}
                      >
                        Save & Continue
                      </Button>
                    </Flex>
                  </Form>
                </LeftSide>
              </Col>
              <Col xs={0} md={12}>
                <RightSide>
                  <div style={{
                    display:'flex',
                    justifyContent:"center",
                    alignItems:"center",
                    maxHeight:"650px",
                    maxWidth:"850px",
                    minHeight:"650px",
                    padding:"20px"
                  }}>
                  <Image
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    src={data?.login_thumbnail ?? IMG_BUSINESS_INFO_RIGHT_BG}
                  />
                  </div>
                </RightSide>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={2} />
      </Row>
    </RootContainer>
  );
};

export default BusinessInfo;
